import React from "react";
import {
  Avatar,
  Badge,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import EditIcon from "../../Icons/EditIcon";
import BackIcon from "../../Icons/BackIcon";
import { BiDotsVerticalRounded } from "react-icons/bi";
import Popover from "@mui/material/Popover";
import ProfileUpdateModal from "../Modals/ProfileUpdateModal";
import RateUpdateModal from "../Modals/RateUpdateModal";
import TeminateEmployeeModal from "../Modals/TerminateEmployeeModal";
import { Link } from "react-router-dom";
import OfferTabs from "./OfferTabs";
import BtnSecondary from "../../../../application/components/Button/BtnSecondary";
import BtnPrimary from "../../../../application/components/Button/BtnPrimary";

function ProfileMoreOptions() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [updateProfileModal, setUpdateProfileModal] = React.useState(false);
  const [updateRatesModal, setUpdateRatesModal] = React.useState(false);

  const [updateDirectDepositModal, setUpdateDirectDepositModal] =
    React.useState(false);
  const [updateW2Modal, setUpdateW2Modal] = React.useState(false);
  const [terminateModal, setTerminateModal] = React.useState(false);

  const changeState = (stateVar, setStateFunc) => {
    setStateFunc(!stateVar);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div className="profile">
      <BiDotsVerticalRounded
        size="1.5rem"
        className="cursor-pointer"
        aria-describedby={id}
        variant="contained"
        onClick={handleClick}
      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <List sx={{ width: "200px" }}>
          <ListItem disablePadding>
            <ListItemButton
              onClick={() =>
                changeState(updateProfileModal, setUpdateProfileModal)
              }
            >
              <ListItemText primary="Update profile" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              onClick={() => changeState(updateRatesModal, setUpdateRatesModal)}
            >
              <ListItemText primary="Update rates" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              onClick={() => changeState(updateW2Modal, setUpdateW2Modal)}
            >
              <ListItemText primary="Update W2" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              onClick={() =>
                changeState(
                  updateDirectDepositModal,
                  setUpdateDirectDepositModal
                )
              }
            >
              <ListItemText primary="Update Direct deposit" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              onClick={() => changeState(terminateModal, setTerminateModal)}
            >
              <ListItemText primary="Terminate" sx={{ color: "red" }} />
            </ListItemButton>
          </ListItem>
        </List>
      </Popover>
      {updateProfileModal && (
        <ProfileUpdateModal
          onClose={() => changeState(updateProfileModal, setUpdateProfileModal)}
        />
      )}
      {updateRatesModal && (
        <RateUpdateModal
          onClose={() => changeState(updateRatesModal, setUpdateRatesModal)}
        />
      )}

      {terminateModal && (
        <TeminateEmployeeModal
          onClose={() => changeState(terminateModal, setTerminateModal)}
        />
      )}
    </div>
  );
}

function ProfileShowcase() {
  return (
    <main className="">
      <div className="p-4">
        <BackIcon url="/dashboard/offers" />
        <section className="mt-8">
          <div className="flex flex-col md:flex-row gap-8 items-start w-full ">
            <div>
              <Badge
                overlap="circular"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                badgeContent={<EditIcon />}
                style={{
                  cursor: "pointer",
                }}
              >
                <Avatar
                  alt="Remy Sharp"
                  src="https://i.pravatar.cc/300"
                  sx={{ width: 150, height: 150, border: "1px solid #1E87FF" }}
                />
              </Badge>
            </div>
            <div className="flex-grow pl-[48px] pr-[31px]">
              <div className="flex justify-between mb-[24px]">
                <p className="text-xl font-bold ">Cameron Williamson</p>
                <ProfileMoreOptions />
              </div>
              <section className="flex flex-col md:flex-row  justify-between flex-grow w-full">
                <div className="w-[25%]">
                  <div className="mb-2">
                    <p className="text-[#98A2B3] text-[12px] font-[500]">
                      Discipline
                    </p>
                    <p className="text-[14px] font-[400]">Registered Nurse</p>
                  </div>
                  <div>
                    <p className="text-[#98A2B3] text-[12px] font-[500]">
                      Status
                    </p>
                    <p className=" text-[#32D583] text-[14px] font-[400]">
                      Active
                    </p>
                  </div>
                </div>

                <div className="w-[25%]">
                  <div className="mb-2">
                    <p className="text-[#98A2B3] text-[12px] font-[500]">
                      Date of hire
                    </p>
                    <p className=" text-[14px] font-[400]">22-05-2023</p>
                  </div>
                  <div>
                    <p className="text-[#98A2B3] text-[12px] font-[500]">
                      Birthday
                    </p>
                    <p className=" text-[14px] font-[400]">12-04-1983</p>
                  </div>
                </div>

                <div className="w-[25%]">
                  <div className="mb-2">
                    <p className="text-[#98A2B3] text-[12px] font-[500]">
                      Type of employment
                    </p>
                    <p className="text-[14px] font-[400]">22-05-2023</p>
                  </div>
                  <div>
                    <p className="text-[#98A2B3]  text-[12px] font-[500]">
                      Termination date
                    </p>
                    <p className="text-[14px] font-[400]">-</p>
                  </div>
                </div>

                <div className="w-[25%]">
                  <div className="mb-2">
                    <p className="text-[#98A2B3] text-[12px] font-[500]">
                      Rates
                    </p>
                    <p className="text-[14px] font-[400]">Soc: $30 per hour</p>
                  </div>
                  <div>
                    <p className="text-[#98A2B3] text-[12px] font-[500]">
                      Address
                    </p>
                    <p className=" text-[14px] font-[400]">
                      3891 Ranchview Dr. Richardson, California 62639
                    </p>
                  </div>
                </div>
              </section>

              <section>
                <div className="flex gap-4 mt-8">
                  <Link to={"/dashboard/offers/need-attention"}>
                    <BtnSecondary
                      variant="contained"
                      size="large"
                      text="Pending files (3)"
                      height="56px"
                    ></BtnSecondary>
                  </Link>

                  <BtnPrimary
                    variant="contained"
                    size="large"
                    text="Send Payroll"
                    height="56px"
                  ></BtnPrimary>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>
      <section>
        <OfferTabs />
      </section>
    </main>
  );
}

export default ProfileShowcase;
